import { useEffect, useState } from "react";
import { Skeleton, Typography, Breadcrumb, Tag } from "antd";
import { useLocation } from "react-router-dom";

interface Props {
  title: string | undefined;
  dayFromToday: null | number;
}
const OrgTitleInfo: React.FC<Props> = ({ title, dayFromToday }) => {
  const { Title } = Typography;
  const location = useLocation();

  const [showSubscribeStatusTag, setShowSubscribeStatusTag] = useState(false);
  const [breadcrumbList, setBreadCrumbList] = useState<any[]>([]);
  const [showTitleInfo, setShowTitleInfo] = useState(true)

  //console.log("Organization title");

  useEffect(() => {
    const { pathname } = location;
    if (
      pathname.includes("users") ||
      pathname.includes("subscription") ||
      pathname.includes("game")
    ) {
      setShowSubscribeStatusTag(true);
    } else {
      setShowSubscribeStatusTag(true)
    }
  }, [location]);

  useEffect(() => {
    const { pathname } = location;
    const temp = [
      {
        title,
      },
    ];

    setShowTitleInfo(true);
    if (pathname.includes("users")) temp.push({ title: "Member Management" });
    else if (pathname.includes("subscription"))
      temp.push({ title: "My Subscriptions" });
    else if (pathname.includes("game"))
      temp.push({ title: "Game Files Download" });
    else if (pathname.includes("activity"))
      setShowTitleInfo(false)
    setBreadCrumbList(temp);
  }, [location, title]);

  if (!showTitleInfo) {
    return <></>
  }

  return (
    <div
      style={{
        background: "white",
        borderRadius: 4,
        boxShadow: "0 0 8px 0 #cbcbcb",
        padding: 20,
        marginBottom: 15
      }}
    >
      {title && breadcrumbList.length > 0 ? (
        <div>
          {breadcrumbList.length > 1 && (
            <Breadcrumb items={breadcrumbList} style={{ marginBottom: 12 }} />
          )}
          <Title level={4} style={{ marginBottom: 0 }}>
            {breadcrumbList[breadcrumbList.length - 1].title}
            {(showSubscribeStatusTag && dayFromToday) && (
              <Tag
                color={
                  dayFromToday > 15
                    ? "cyan"
                    : dayFromToday >= 0
                    ? "orange"
                    : "red"
                }
                style={{ marginLeft: 12 }}
              >
                {dayFromToday > 15
                  ? "Subscribed"
                  : dayFromToday >= 0
                  ? "Expiring"
                  : "Expired"}
              </Tag>
            )}
          </Title>
        </div>
      ) : (
        <Skeleton
          paragraph={{ rows: breadcrumbList.length }}
          title={false}
          active
        />
      )}
    </div>
  );
};

export default OrgTitleInfo;
